import StatusBadge from "../../components/common/StatusBadge";

const columns = [
  {
    title: "Client",
    dataIndex: "userDetails",
    fixed: "left",
  },
  {
    title: "File Number",
    dataIndex: "file_number",
    key: "file_number",
  },
  {
    title: "Service",
    dataIndex: "service_name",
    key: "service_name",
  },
  {
    title: "E-File Ack No",
    dataIndex: "acknowledge_ment_no",
    key: "acknowledge_ment_no",
  },
  {
    title: "E-File Ack Doc",
    dataIndex: "acknowledgement_doc",
    key: "acknowledgement_doc",
  },
  {
    title: "Running Tasks",
    dataIndex: "running_task",
    key: "running_task",
  },
  {
    title: "Completed Tasks",
    dataIndex: "completed_task",
    key: "completed_task",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
  },
  {
    title: "File Status",
    dataIndex: "file_status",
    key: "file_status",
    render: (value) => <StatusBadge status={value} />,
  },
];

export default columns;
